import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchSavedLocations, addSavedLocation, deleteSavedLocation } from './api';

export const SAVED_LOCATIONS_KEY = ['saved-locations'] as const;

export function useSavedLocations() {
  return useQuery({
    queryKey: SAVED_LOCATIONS_KEY,
    queryFn: fetchSavedLocations,
  });
}

export function useAddSavedLocation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (loc: {
      label: string;
      address: string;
      lat?: number | null;
      lng?: number | null;
    }) => addSavedLocation(loc),
    onSuccess: () => qc.invalidateQueries({ queryKey: SAVED_LOCATIONS_KEY }),
  });
}

export function useDeleteSavedLocation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteSavedLocation(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: SAVED_LOCATIONS_KEY }),
  });
}
